<template>
  <div>
    <list
      row-key="FreightId"
      ref="list"
      unit="不支持配送区域"
      :page="page"
      :query-params="params"
      :show-checkbox="showCheckbox"
      :show-query="showQuery"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">  
        
        <!-- <el-form-item
          label="所属商家"
          prop="StoreId"   
           v-if="$permission.isStore() == false"     
        >
          <busi-select
            v-model="params.StoreId"
            ref="busiSelect"
          ></busi-select>
        </el-form-item> -->
        <el-form-item label="区域名称">
          <el-input
            v-model="params.AreaName"
            placeholder="请输入区域名称"
            clearable
          />
        </el-form-item>
       
      </template>
      <template slot="table">
        <!-- <el-table-column
          prop="BusiName"
          label="所属商家"
          v-if="$permission.isStore() == false"
        /> -->
        <el-table-column prop="AreaName" label="区域名称" />

        <!-- slot[column] -->
        
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import busiSelect from "@/components/shop/business/select";

export default {
  mixins: [listMixin],
  components: { list ,busiSelect},
  data() {
    return {
      api: require("@/api/sale/freightUnsupport").default,
      params: {
        TemplateName: "",
        DeliveryRange: null,
        DeliveryWay: null,
        State: null,
      },
    };
  },
  mounted() {
    this.$refs.list.query();
  },
  methods: {
    // getDataFunc(params) {
    //   return new Promise((resolve,reject) => {
    //     resolve({Data:[]})
    //   })
    // },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>